import React from 'react';
import { BrowserRouter, Routes, Route, Link ,useLocation} from 'react-router-dom';
import Portfolio from './Portfolio';
import Contact from './Contact';
import Admin from './admin/Admin';
import AdminLogin from './AdminLogin';
import ProtectedRoute from './admin/protectedRoute';
import Home from './Home';
import './App.css';

const e = React.createElement;

function Navigation() {
  const location = useLocation(); // Gets the current URL
  
  // Check if we are currently on the admin page
  const isAdminPage = location.pathname === '/admin';

  const handleLogout = () => {
    localStorage.removeItem('userToken');
    window.location.href = '/';
  }

  return e('nav', { className: 'navbar' },
      e('h2', null, 'Last Heaven'),
      e('div', { className: 'nav-links' },
      e(Link, { to: '/' }, 'Home'),
      e(Link, { to: '/portfolio' }, 'Portfolio'),
      e(Link, { to: '/contact' }, 'Contact Us'),
      isAdminPage 
        ? e('button', { 
            onClick: handleLogout,
            style: { marginLeft: '20px', backgroundColor: 'transparent', color: '#ff4c4c', border: '1px solid #ff4c4c', cursor: 'pointer', padding: '5px 10px', borderRadius: '4px' }
          }, 'Logout')
        : null
      )
    );
}

function App() {
  return e(BrowserRouter, null,
    e('div', { className: 'app-container' },
      e(Navigation),  
    
      e(Routes, null,
      e(Route, {path:'/admin/Message', element:e(Admin)}),
      e(Route, { path: '/', element: e(Home) }),
      e(Route, { path: '/portfolio', element: e(Portfolio) }),
      e(Route, { path: '/contact', element: e(Contact) }),
      e(Route, { path: '/adminlogin', element: e(AdminLogin) }),
      e(Route, { 
          path: '/admin', 
          element: e(ProtectedRoute, null, e(Admin)) 
        })
      )
    )
  );
}

export default App;